export interface PaginateConfig {
	pageSize?: number;
	pageNumber: number;
}

const SMALL = 25;
const MEDIUM = 50;
const LARGE = 75;

export const defaultPageSizes = [SMALL, MEDIUM, LARGE];

export const DEFAULT_PAGE_SIZE = SMALL;
export const FIRST_PAGE = 1;
